import Headlines from "components/Headlines"

const TopStories = () => {
  return (
    <div>
      <br />
      <h4>Top stories</h4>
      <Headlines />
    </div>
  )
}

export default TopStories
